import { render, staticRenderFns } from "./postsaleOEM.vue?vue&type=template&id=3ee8d90d&"
import script from "./postsaleOEM.vue?vue&type=script&lang=ts&"
export * from "./postsaleOEM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports